var module = angular.module('octopusApp.projects');

module.controller('TenantVariablesLibraryController', function ($scope, $q, $location, $state, tenantState, tabState, octopusPermissionSet, octopusRepository, unsavedChanges, missingTenantVariablesLoader) {
    var vm = this;
    var tenantId = tenantState.tenantId;
    vm.libraryTemplateDetails = [];
    vm.hasLibraryTemplates = false;
    vm.save = save;
    vm.isLibraryFiltered = isLibraryFiltered;

    vm.allAccounts = [];
    var variables;

    function isLibraryFiltered(libraryVariableSet) {
        return libraryVariableSet.templates.length > 0;
    }

    function init() {
        tenantState.missingVariables = missingTenantVariablesLoader.missingVariables(tenantId);

        octopusPermissionSet.isAuthorized({permission: 'LibraryVariableSetView'}).then(function (isAuthorized) {
            if (!isAuthorized) {
                return $location.path("/tenants/" + tenantId + "/variables/projects");
            }

            tabState.isLoading.promise(tenantState.load()
                .then(function (tenant) {
                    vm.tenant = tenant;
                    return octopusRepository.Tenants.getVariables(tenant);
                }).then(function (tenantVariables) {
                    variables = tenantVariables;
                }).then(loadAccountsIfAzurePresent)
                .then(refreshLibraryTemplates)
            );

            tabState.isLoading.promise(tenantState.missingVariables.loadingAsync);
        });
    }

    function loadAccountsIfAzurePresent(){
        var areAnyTemplateTypesAzure = _.any(variables.LibraryVariables, function (lvs) {
            return _.any(lvs.Templates, isAzureAccountTemplate);
        });

        if (areAnyTemplateTypesAzure) {
            return octopusRepository.Accounts.all().then(function (acc) {
                vm.allAccounts = acc;
            });
        }

        function isAzureAccountTemplate(template) {
            return template.DisplaySettings['Octopus.ControlType'] === 'AzureAccount';
        }
    }

    function refreshLibraryTemplates() {
        vm.hasLibraryTemplates = false;
        vm.libraryTemplateDetails = _.map(variables.LibraryVariables, function(libraryVariableDetails, id) {
            vm.hasLibraryTemplates = vm.hasLibraryTemplates || libraryVariableDetails.Templates.length > 0;

            _.each(libraryVariableDetails.Templates, function (template) {
                if (!libraryVariableDetails.Variables[template.Id] && typeof template.DefaultValue !== 'undefined' && template.DefaultValue !== null && template.DefaultValue !== '') {
                    libraryVariableDetails.Variables[template.Id] = template.DefaultValue;
                }
                template.isMissingValue = tenantState.missingVariables.isMissing(template.Id);
            });

            return {
                id: libraryVariableDetails.LibraryVariableSetId,
                name: libraryVariableDetails.LibraryVariableSetName,
                templates: libraryVariableDetails.Templates,
                localNames: _.pluck(libraryVariableDetails.Templates, "Name"),
                Properties: libraryVariableDetails.Variables
            };
        });
    }

    function save() {
        variables.LibraryVariableSetVariableTemplates = modelToResource();

        tenantState.isSaving.promise(octopusRepository.Tenants.setVariables(vm.tenant, variables).then(function (a) {
            unsavedChanges.saved();
            init();
        }));

        function modelToResource() {
            return vm.libraryTemplateDetails.reduce(function (idx, a) {
                idx[a.id] = {
                    LibraryVariableSetId: a.id,
                    LibraryVariableSetName: a.name,
                    Templates: a.templates,
                    Variables: a.Properties
                };
                return idx;
            }, {});
        }
    }

    init();
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/variables/tenant_variables_library.js
// module id = 7884614219142530
// module chunks = 1